<template>
<v-row class="pt-1">
    <v-col col="12" sm="3">
        {{type}}
    </v-col>
    <v-col col="12" sm="9">
        <div v-if="isEmail">
            <a :href="`mailto: ${contactInfo}`">{{contactInfo}}</a>
        </div>
        <div v-else-if="isPhoneNumber">
            <a :href:="`tel: ${contactInfo}`">{{formattedPhoneNumber}}</a>
        </div>
        <div v-else>
            {{contactInfo}}
        </div>
    </v-col>
</v-row>
</template>

<script>
export default {
    name: "ProfileContactRow",
    props: {
        type: String,
        contactInfo: String
    },
    computed: {
        isEmail () {
            return this.type.toLowerCase().includes('email')
        },
        isPhoneNumber () {
            return this.type.toLowerCase().includes('phone')
        },
        formattedPhoneNumber () {
             return `(${this.contactInfo.slice(2, 5)}) ${this.contactInfo.slice(5,8)} - ${this.contactInfo.slice(8,)}`
        },
    }
}
</script>

<style>

</style>